// Number + unit formatting helpers. Keep all display formatting here.

export function round(n: number, dp = 2): number {
  const f = 10 ** dp
  return Math.round((n + Number.EPSILON) * f) / f
}

/** Round UP to the next purchasable unit (e.g. 2.1 gal -> 2.25 at step 0.25).
 *  A tiny epsilon absorbs floating-point noise (100 * 1.1 = 110.00000000001)
 *  so we never over-estimate by a whole unit. */
export function ceilTo(n: number, step = 1): number {
  return Math.ceil(n / step - 1e-9) * step
}

export function fmtNum(n: number, dp = 0): string {
  return n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: dp })
}

export function pluralize(n: number, singular: string, plural?: string): string {
  return n === 1 ? singular : plural ?? `${singular}s`
}

export function fmtQty(n: number, unit: string): string {
  return `${fmtNum(n, 2)} ${pluralize(n, unit)}`
}
